export const composeSendButton = "h$a";
export default {composeSendButton};